import styled from "styled-components"

export const DiscountContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;

  h4 {
    margin-top: 1rem;
    line-height: 2.8rem;
    font-size: 2.2rem;
    text-align: center;

    em,
    strong {
      color: ${(props) => props.theme.component.highlight};
      font-style: inherit;
    }
  }

  p {
    font-size: 1.5rem;
  }
`

export const AffirmContainer = styled.div`
  height: 6rem;

  .affirm-modal-trigger {
    text-decoration: underline;
    color: #00a3b7;
  }

  .affirm-as-low-as {
    text-align: center;
    font-size: 1.8rem;
  }

  .__affirm-logo.__affirm-logo-blue {
    color: ${({ theme }) =>
      theme.component.isDarkBackground ? "#fff" : theme.colors.text.primary};
  }
`
